import { css } from 'styled-components';
import { royalBlue } from '../../../utils/customColors';

export const highlightedTextStyles = css`
    color: ${royalBlue};
    display: inherit;
`;
